export default __webpack_public_path__ + "static/media/Screenshot 2020-07-29 13.44.57.928aad55.png";